// test30
(30 && 0);
